import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../styles/Label.module.css";
var Label = function (_a) {
    var children = _a.children, htmlFor = _a.htmlFor;
    return (_jsx("label", { htmlFor: htmlFor, className: styles.label, children: children }));
};
export default Label;
